__turbopack_context__.v({
  "actions": "GPFauq_actions",
  "banner": "GPFauq_banner",
  "copyLine": "GPFauq_copyLine",
  "email": "GPFauq_email",
  "emailLabel": "GPFauq_emailLabel",
  "headline": "GPFauq_headline",
  "icon": "GPFauq_icon",
  "main": "GPFauq_main",
  "verifyCta": "GPFauq_verifyCta",
  "verifyCtaDivider": "GPFauq_verifyCtaDivider",
  "verifyCtaLabel": "GPFauq_verifyCtaLabel",
  "verifyCtaStatus": "GPFauq_verifyCtaStatus",
});
